/**
 * Labstep
 *
 * @module components/ProtocolTimer/Modal
 * @desc Modal for protocol timer
 */

import { ProtocolTimerModalContentContainer as ProtocolTimerModalContent } from 'labstep-web/components/ProtocolTimer/Modal/Content';
import { ModalDefaultContainer as Modal } from 'labstep-web/core/Modal/Default';
import type React from 'react';
import type { IProtocolTimerModalProps } from './types';

export const ProtocolTimerModal: React.FC<
  IProtocolTimerModalProps
> = ({ protocol, protocolTimer, viewComponent }) => (
  <Modal
    header={protocolTimer.name}
    viewComponent={viewComponent}
    content={
      <ProtocolTimerModalContent
        protocol={protocol}
        protocolTimer={protocolTimer}
      />
    }
  />
);
